import type { AuthUser } from "../../../api/WarehouseApi";
import type { AuthUserProfile } from "../../../utils/authStorage";

export function hasProfileFormChanges(input: {
  profile: AuthUser | null;
  profileNameInput: string;
  profilePhotoInput: string;
}): boolean {
  if (!input.profile) {
    return false;
  }

  const nextName = input.profileNameInput.trim();
  const nextPhoto = input.profilePhotoInput.trim();
  const currentName = input.profile.name.trim();
  const currentPhoto = (input.profile.photo || "").trim();

  return nextName !== currentName || nextPhoto !== currentPhoto;
}

export function hasEmailFormChanges(input: {
  profile: AuthUser | null;
  profileEmailInput: string;
}): boolean {
  const nextEmail = input.profileEmailInput.trim().toLowerCase();
  const currentEmail = (input.profile?.email || "").trim().toLowerCase();
  return nextEmail !== currentEmail;
}

export function buildStoredUserProfilePatch(
  profile: AuthUser,
): Partial<AuthUserProfile> {
  return {
    id: profile.id,
    name: profile.name,
    email: profile.email || null,
    photo: profile.photo,
    role: profile.role,
  };
}
